export default __webpack_public_path__ + "static/media/menuMover.a767fe56.svg";